import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import classes from './Header.module.css';
import { Navbar, Nav, Container } from 'react-bootstrap';
import {
  Link,
  NavLink,
} from "react-router-dom";
import logo from '../images/logo.png';


export default function Header() {
  return (
    <Navbar collapseOnSelect expand="md" variant="light">
      <Container>
        <Navbar.Brand>
          <Link to="/presentation"><img src={logo} alt="logo" className={classes.brand}/></Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-center">
          <Nav>
              <NavLink className='main-nav' activeClassName='main-nav-active' to="/business_center">Бизнес-центр</NavLink>
              <NavLink className='main-nav' activeClassName='main-nav-active' to="/rent">Аренда</NavLink>
              <NavLink className='main-nav' activeClassName='main-nav-active' to="/contacts">Контакты</NavLink>
          </Nav>
        </Navbar.Collapse>
        </Container>
    </Navbar>
  );
}